/*
 * hg-card-image-load.js
 *
 * Removes the skeleton shimmer and fades in card-grid images once they load, so the
 * Shop All variant grid (and any .hg-collection-card grid) doesn't pop in abruptly.
 *
 * CSS (hazy-grove-custom.css) starts each .hg-collection-card__media with an animated
 * ::after shimmer and its primary <img> at opacity 0; adding .hg-img-loaded to the media
 * box clears the shimmer and fades the image in. Loaded globally so it runs on every page
 * that renders these cards — without it the primary images would stay hidden.
 */
(function () {
  function markLoaded(media) {
    if (media && !media.classList.contains('hg-img-loaded')) {
      media.classList.add('hg-img-loaded');
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;

    // Primary images: reveal as each one loads (or is already cached / errors out).
    var imgs = scope.querySelectorAll('.hg-collection-card__media-img--primary');
    Array.prototype.forEach.call(imgs, function (img) {
      var media = img.closest('.hg-collection-card__media');
      if (img.complete && img.naturalWidth > 0) {
        markLoaded(media);
      } else {
        img.addEventListener('load', function () { markLoaded(media); }, { once: true });
        img.addEventListener('error', function () { markLoaded(media); }, { once: true });
      }
    });

    // Placeholder cards (no <img>) have nothing to load — clear their shimmer immediately.
    var medias = scope.querySelectorAll('.hg-collection-card__media');
    Array.prototype.forEach.call(medias, function (media) {
      if (!media.querySelector('.hg-collection-card__media-img--primary')) {
        markLoaded(media);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Re-run for sections re-rendered by the theme editor or AJAX facet/cart updates.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { init(e.target); });
})();
